import NewTodo from "./components/NewTodo";
import Todos from "./components/Todos";
import TododsContextProvider from "./store/todos-context";

import classes from "./App.module.css";

function App() {
  return (
    <TododsContextProvider>
      <div className={classes.title}>
        <h1>Todo Tracker</h1>
      </div>
      <NewTodo />
      <Todos />
    </TododsContextProvider>
  );
}

export default App;
